import { render, staticRenderFns } from "./zvit.vue?vue&type=template&id=21c8a7f3&scoped=true&"
import script from "./zvit.vue?vue&type=script&lang=js&"
export * from "./zvit.vue?vue&type=script&lang=js&"
import style0 from "./zvit.vue?vue&type=style&index=0&id=21c8a7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8a7f3",
  null
  
)

export default component.exports